import React, { useState , useEffect } from "react";
import styles from "./Time.module.css";
import SquareRadio from '../Utilities/SquareRadio'
import { useTranslation } from "react-i18next";
import DatePicker2 from "./DatePicker";
import { useDispatch, useSelector} from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import notify from "../Utilities/notify";
import { editService, reservationServiceFromPackage } from "../../redux/Slices/reservation/thunk";
import { getScheduleTime } from "../../redux/Slices/Time/thunk";
import Modal from "react-modal";


const TimeForPackage = ({details, servicesCard,header , header2, ServiceStatus,isEdit,startDateFromEdit, service, servicesId2, servicesId3}) => {



  //  i want EndDateFromPackage and StartDate
  // i want endPoint to make Edit 

  const [selectedInput, setSelectedInput] = useState();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const dispatch= useDispatch();
  const navigate = useNavigate();
  let branchId= header?.ith_brn;
// ✅ استخلاص التاريخ من المصدر
let rawStartDate = header2?.itd_dat || startDateFromEdit;

if (rawStartDate) {
  // 🔄 استبدل / بـ -
  let formattedDate = rawStartDate.replace(/\//g, '-');

  // 🔁 لو التاريخ بصيغة DD-MM-YYYY نحوله لـ YYYY-MM-DD
  const convertToISOFormatIfNeeded = (dateStr) => {
    const parts = dateStr.split("-");
    if (parts.length === 3 && parts[0].length === 2) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateStr;
  };

  formattedDate = convertToISOFormatIfNeeded(formattedDate);

  // 🧠 تحويل التاريخ إلى كائن Date
  let startDateObj = new Date(formattedDate);
  let today = new Date();
  today.setHours(0, 0, 0, 0); // نحذف الوقت من اليوم
  startDateObj.setHours(0, 0, 0, 0); // نحذف الوقت من startDate

  // ⏱️ المقارنة، لو startDate قديم → خليه النهاردة
  if (startDateObj < today) {
    startDateObj = today;
  }

  // 🟢 تحويل startDate النهائي إلى string بصيغة YYYY-MM-DD
  const yyyy = startDateObj.getFullYear();
  const mm = String(startDateObj.getMonth() + 1).padStart(2, '0');
  const dd = String(startDateObj.getDate()).padStart(2, '0');
  var startDate = `${yyyy}-${mm}-${dd}`;
} else {
  var startDate = "";
}

  let packageSerial= header?.ith_num;
  let packageNumber= header2?.itd_itmsrl;
  let branchNameAR= header2?.brn_nam;
  let branchNameEN= header2?.brn_enm;
  let endDate= header2?.to_dat.replace(/\//g, '-');
console.log("startDate",startDate,"header?.ith_dat",header, "startDateFromEdit",startDateFromEdit)
  const [selectedDate, setSelectedDate] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [selectedEndTime, setSelectedEndTime] = useState();
  const [selectedMin, setSelectedMin] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [date, setDate] = useState(startDate);
   const {scheduleTime, loading } = useSelector((state) => state.TimeSlice);
   console.log("service", service);
   console.log("servicesId3", servicesId3);
    const getCurrentDate = (date) => {
      if (!date) return ""; 
    
      const [year,month,day] = date.split("-");
      console.log("day",day)
      console.log("month",month)
      console.log("year",year)
      return `${year}/${month}/${day}`; // Rearrange to YYYY/MM/DD format
    };
    
    const nowDate = getCurrentDate(date);
    console.log("nowDate", nowDate);
  

    useEffect(() => {
      if (!nowDate) return; 
      let query = `empNum=${details?.empi_num}&date=${nowDate}`;
    
      dispatch(getScheduleTime({ query }));
      setSelectedTime();
      setSelectedInput();
    }, [nowDate]);

const firstSubmit = ()=>{
  console.log("endDate",endDate)
  console.log("startDate",startDate)
  console.log("date",date)
  console.log("selectedTime",selectedTime)
  if(Date(date) > Date(endDate) || Date(date) < Date(startDate))
    {
      console.log(date > endDate)
    return notify(t("selectDateTimeMessage"),"error")
  } 
  console.log("Date : ", date ,"Start  : ", startDate , "check : " , Date(date) < Date(startDate))
  
    if(!date || !selectedTime){
      return notify(t("selectDateTimeMessage"),"error")
    }
    setOpenModal(true);
}

const onSubmit = async ()=>{

  
    const data = {
      branchId: branchId,
      serviceId:details?.itd_itmsrl?.trim(),
      employeeId:details?.empi_num,
      packageSerial: packageSerial,
      packageNumber: packageNumber,
      serviceTime :selectedTime,
      logIn :selectedTime,
      logOut :selectedEndTime,
      servicesDate: selectedDate,
      serviceMin: selectedMin
    }
    console.log("data",data)

    if(Date(date) > Date(endDate) || Date(date) < Date(startDate))
      {
    return notify(t("selectDateTimeMessage"),"error")
  } 
  
    if(!date || !selectedTime){
      return notify(t("selectDateTimeMessage"),"error")
    }
    // return;
    if(isEdit){
      let editData ={
        type:"fromPackage",
        serviceSerial:servicesId2,
        employeeId:details?.empi_num,
        serviceTime :selectedTime,
        servicesDate: selectedDate,
        serviceMin: selectedMin,
        logIn :selectedTime,
        logOut :selectedEndTime
      }
      setIsLoading(true)
      
      await dispatch(editService({
        id:header?.ith_num,
        data:editData
      }))
      navigate('/bookings')
      setIsLoading(false)
    }
    else{
      setIsLoading(true)
      await dispatch(reservationServiceFromPackage({data}))
      navigate('/bookings')
      setIsLoading(false)
    }
  // }

}



const onChangeHandlar = (slot, index) => {
  console.log("Selected Slot:", slot); 
  setSelectedInput(index);
  setSelectedDate(slot?.schd_dat);
  setSelectedTime(slot?.schd_timein);
  setSelectedEndTime(slot?.schd_timeout);
  setSelectedMin(slot?.schd_servicetime);
  console.log("selectedInput",selectedInput)
};

return (
  <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
  
<div className={styles.mainContainer} >



<DatePicker2 setDate={setDate} startDate={startDate} endDate={endDate} />
{loading ?  <div style={{display:"flex", justifyContent:"center"}}>
         
         <Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
        </div> 
        : 
    <div className={styles.TimeComponant}>
    {scheduleTime?.map((slot, index) => (
          <div key={index} style={{ opacity: (slot?.balcount == 0 || ServiceStatus?.payload?.serviceObject?.itm_hassrl > slot?.schd_servicetime || slot?.is_disabled) ? 0.5 : 1 }} className="d-flex justify-content-between">
             <SquareRadio
              value={selectedInput == index}
              onChange={() => onChangeHandlar(slot,index)}
              name="timeRange"
              checked={selectedInput == index}
              disabled={slot.balcount == 0 || servicesCard?.itm_hassrl > slot?.schd_servicetime || slot?.is_disabled} 
              // disabled={slot.isDisabled}
            />

            <div>{t('from')}</div>
            <div className={styles.TimeBox} >
              <span style={{textAlign:"center", margin:"auto"}}>{slot.schd_timein}</span>
            </div>
            <div>{t('to')}</div>
            <div className={styles.TimeBox} >
              <span style={{textAlign:"center", margin:"auto"}}>{slot.schd_timeout}</span>
            </div>
          </div>
        ))}
  </div>}

  </div>
  <div className={styles.onSubmit} onClick={firstSubmit} disabled={isLoading} >
         { isLoading ? <Spinner /> : t('send')} 
        </div>

        {/* Modal */}
{openModal &&
  <Modal
  isOpen={openModal}
  onRequestClose={()=>{setOpenModal(false)}}
  contentLabel="Date Picker Modal"
  ariaHideApp={false}
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    content: {
      width: "700px",
      height: "500px",
      margin: "auto",
      padding: "20px",
      borderRadius: "10px",
      display: "flex",
      flexDirection: "column",
      inset: 0,
      justifyContent:"space-between",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  }}
>
  <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
    {t("confirmServicereservation")}
  </h1>
  
    <div
      className={styles.DetailsComponant}
      style={{ border: "none", display:"flex",flexDirection:"column",gap:"15px" }}
    >
     <div style={{display:"flex", gap:"10px", fontSize:"18px",fontWeight:"700"}}>
      <div style={{width:"150px"}}>{`${t('Service Name')} : `}</div>
{      <div>{currentLanguage == "ar" ? servicesCard?.itm_nam2 || service?.itd_itm_nam : servicesCard?.itm_enm2 ||  service?.itd_itm_enm}</div>}
     </div>
     <div style={{display:"flex", gap:"10px", fontSize:"18px",fontWeight:"700"}}>
      <div style={{width:"150px"}}>{`${t('package Name')} : `}</div>
      <div>{currentLanguage == "ar" ? header?.ith_pac_nam : header?.ith_pac_enm}</div>
     </div>
     <div style={{display:"flex", gap:"10px", fontSize:"18px",fontWeight:"700"}}>
      <div style={{width:"150px"}}>{`${t('serviceProvider')} : `}</div>
      <div>{currentLanguage == "ar" ? details?.emp_namar : details?.emp_namen}</div>
     </div>
     <div style={{display:"flex", gap:"10px", fontSize:"18px",fontWeight:"700"}}>
     <div style={{width:"150px"}}>{`${t('branch')} : `}</div>
      <div>{currentLanguage == "ar" ? branchNameAR : branchNameEN}</div>
     </div>
     <div style={{display:"flex", gap:"10px", fontSize:"18px",fontWeight:"700"}}>
     <div style={{width:"150px"}}>{`${t('reservationDate')} : `}</div>
      <div>{date}</div>
     </div>
     <div style={{display:"flex", gap:"10px", fontSize:"18px",fontWeight:"700"}}>
     <div style={{width:"150px"}}>{`${t('reservationTime')} : `}</div>
      <div>{selectedTime || ""}</div>
     </div>
    </div>
    <div className={styles.onSubmit} onClick={onSubmit} disabled={isLoading} style={{height:"50px"}} >
{ isLoading ? <Spinner /> : t('ReservationDone')} 
</div>
 
</Modal>
}
      
  </div>
);
};

export default TimeForPackage;
